module.exports = __webpack_public_path__ + "static/img/5123.ce8bf29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5123.jpg
// module id = eJa8
// module chunks = 0